import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyPages.css';

import luminaLogo from '../assets/luminalogo3.png';

const PrivacyPage = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-page">
            <div className="policy-container">
                <div className="policy-header">
                    <img src={luminaLogo} alt="Lumina Logo" className="policy-logo" />
                    <div className="policy-divider" />
                    <h1 className="policy-title">Datenschutzerklärung</h1>
                </div>

                <div className="policy-content">
                    <section>
                        <h2>1. Datenschutz auf einen Blick</h2>

                        <h3>Allgemeine Hinweise</h3>
                        <p>
                            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
                            passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
                            persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen
                            Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                        </p>

                        <h3>Datenerfassung auf dieser Website</h3>

                        <h4>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
                        <p>
                            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
                            können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                        </p>

                        <h4>Wie erfassen wir Ihre Daten?</h4>
                        <p>
                            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um
                            Daten handeln, die Sie in ein Kontaktformular eingeben.
                        </p>
                        <p>
                            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-
                            Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit
                            des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
                        </p>

                        <h4>Wofür nutzen wir Ihre Daten?</h4>
                        <p>
                            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere
                            Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge
                            geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote,
                            Bestellungen oder sonstige Auftragsanfragen verarbeitet.
                        </p>

                        <h4>Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
                        <p>
                            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer
                            gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
                            Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                            können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                            bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                            Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                        </p>
                        <p>
                            Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
                        </p>
                    </section>

                    <section>
                        <h2>2. Hosting</h2>

                        <h3>Externes Hosting</h3>
                        <p>
                            Diese Website wird extern gehostet. Das Frontend wird über Vercel gehostet, das Backend über Railway.
                            Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern der Hoster gespeichert.
                            Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten,
                            Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                        </p>
                        <p>
                            Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
                            bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten
                            Bereitstellung unseres Online-Angebots durch professionelle Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
                        </p>
                        <p>
                            Unsere Hoster werden Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung ihrer
                            Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.
                        </p>

                        <h3>Datenübermittlung in Drittländer</h3>
                        <p>
                            Einige der von uns eingesetzten Dienstleister (Vercel, Railway, Cloudinary) befinden sich in den USA oder Israel
                            und können Daten außerhalb der Europäischen Union verarbeiten. Diese Übermittlungen erfolgen auf Grundlage
                            von EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO) sowie zusätzlichen technischen und organisatorischen
                            Maßnahmen zum Schutz Ihrer Daten.
                        </p>
                        <p>
                            Für Übermittlungen in die USA stützen wir uns auf das EU-U.S. Data Privacy Framework, soweit die jeweiligen
                            Dienstleister dort zertifiziert sind. Weitere Informationen zu den Schutzmaßnahmen können Sie auf Anfrage bei
                            uns erhalten.
                        </p>
                    </section>

                    <section>
                        <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>

                        <h3>Datenschutz</h3>
                        <p>
                            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
                            personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie
                            dieser Datenschutzerklärung.
                        </p>
                        <p>
                            Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
                            Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende
                            Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie
                            und zu welchem Zweck das geschieht.
                        </p>
                        <p>
                            Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail)
                            Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
                            möglich.
                        </p>

                        <h3>Hinweis zur verantwortlichen Stelle</h3>
                        <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
                        <p className="contact-info">
                            Luka Vukosavljevic, LuminaQR<br />
                            Straubinger Straße 22a<br />
                            4600 Wels, Österreich<br />
                            Telefon: 06765019011<br />
                            E-Mail: contact@luminaqr.com
                        </p>
                        <p>
                            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über
                            die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.)
                            entscheidet.
                        </p>

                        <h3>Speicherdauer</h3>
                        <p>
                            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben
                            Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein
                            berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen,
                            werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
                            personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                            letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
                        </p>

                        <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                        <p>
                            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine
                            bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
                            Datenverarbeitung bleibt vom Widerruf unberührt.
                        </p>

                        <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
                        <p>
                            Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer
                            Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
                            oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger
                            verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                        </p>

                        <h3>Recht auf Datenübertragbarkeit</h3>
                        <p>
                            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
                            automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format
                            aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
                            verlangen, erfolgt dies nur, soweit es technisch machbar ist.
                        </p>

                        <h3>Auskunft, Löschung und Berichtigung</h3>
                        <p>
                            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche
                            Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den
                            Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie
                            zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
                        </p>

                        <h3>Recht auf Einschränkung der Verarbeitung</h3>
                        <p>
                            Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                            Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in
                            folgenden Fällen:
                        </p>
                        <ul>
                            <li>
                                Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir
                                in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die
                                Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                            </li>
                            <li>
                                Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie
                                statt der Löschung die Einschränkung der Datenverarbeitung verlangen.
                            </li>
                            <li>
                                Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
                                Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der
                                Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                            </li>
                            <li>
                                Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen
                                Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
                                überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten
                                zu verlangen.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>4. Datenerfassung auf dieser Website</h2>

                        <h3>Cookies und Tracking</h3>
                        <p>
                            Diese Website verwendet <strong>keine Cookies</strong> zu Marketing- oder Tracking-Zwecken. Wir setzen
                            keine Analyse-Tools wie Google Analytics oder ähnliche Dienste ein, die Ihr Nutzerverhalten verfolgen.
                        </p>
                        <p>
                            Technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind (z. B. Session-Cookies
                            für die Anmeldung), werden nur mit Ihrer Zustimmung gesetzt bzw. sind für die Vertragserfüllung erforderlich
                            (Art. 6 Abs. 1 lit. b DSGVO).
                        </p>

                        <h3>Registrierung und Bestellungen</h3>
                        <p>
                            Bei der Registrierung auf unserer Website erfassen wir folgende personenbezogene Daten:
                        </p>
                        <ul>
                            <li>Vorname</li>
                            <li>Nachname</li>
                            <li>E-Mail-Adresse</li>
                            <li>Passwort (verschlüsselt gespeichert)</li>
                        </ul>
                        <p>
                            Bei Bestellungen erfassen wir zusätzlich:
                        </p>
                        <ul>
                            <li>Lieferadresse</li>
                            <li>Rechnungsadresse (falls abweichend)</li>
                            <li>Bestellinformationen</li>
                        </ul>
                        <p>
                            Diese Daten werden zur Vertragserfüllung und zur Bearbeitung Ihrer Bestellungen benötigt.
                            Die Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO.
                        </p>

                        <h3>Bildspeicherung und EXIF-Daten</h3>
                        <p>
                            Für die Speicherung von hochgeladenen Bildern (z. B. für QR-Code-Memorials) nutzen wir den Cloud-Service Cloudinary.
                            Die Bilder werden sicher auf den Servern von Cloudinary gespeichert und sind nur für autorisierte Benutzer zugänglich.
                        </p>
                        <p>
                            <strong>EXIF-Metadaten:</strong> Beim Hochladen von Bildern werden möglicherweise enthaltene EXIF-Metadaten
                            (z. B. GPS-Standortdaten, Kameramodell) automatisch entfernt, um Ihre Privatsphäre zu schützen.
                        </p>
                        <p>
                            <strong>Löschung von Bildern:</strong> Sie können jederzeit die Löschung Ihrer hochgeladenen Bilder verlangen,
                            indem Sie uns per E-Mail kontaktieren oder diese in Ihrem Account selbst löschen.
                        </p>

                        <h3>Profiling und automatisierte Entscheidungen</h3>
                        <p>
                            Diese Website setzt <strong>kein Profiling</strong> oder automatisierte Entscheidungsfindung
                            (Art. 22 DSGVO) ein. Alle Verarbeitungen erfolgen manuell oder basierend auf Ihren expliziten Eingaben,
                            ohne dass automatisierte Systeme Entscheidungen über Sie treffen.
                        </p>

                        <h3>Kontaktformular</h3>
                        <p>
                            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
                            Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
                            und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
                            Einwilligung weiter.
                        </p>
                        <p>
                            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit
                            der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
                            erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der
                            effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
                            Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
                        </p>
                        <p>
                            Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung
                            auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt
                            (z. B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen –
                            insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.
                        </p>
                    </section>

                    <section>
                        <h2>5. Soziale Medien</h2>

                        <h3>Instagram</h3>
                        <p>
                            Auf dieser Website sind Funktionen des Dienstes Instagram eingebunden. Diese Funktionen werden
                            angeboten durch die Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland.
                        </p>
                        <p>
                            Wenn das Social-Media-Element aktiv ist, wird eine direkte Verbindung zwischen Ihrem Endgerät und dem
                            Instagram-Server hergestellt. Instagram erhält dadurch Informationen über den Besuch dieser Website
                            durch Sie.
                        </p>
                        <p>
                            Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und §
                            25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
                        </p>
                        <p>
                            Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von Instagram:
                            {' '}<a href="https://privacycenter.instagram.com/policy/" target="_blank" rel="noopener noreferrer">
                            https://privacycenter.instagram.com/policy/
                        </a>
                        </p>
                    </section>

                    <section>
                        <h2>6. Plugins und Tools</h2>

                        <h3>Google Fonts (lokales Hosting)</h3>
                        <p>
                            Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google
                            bereitgestellt werden. Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von Google findet
                            dabei nicht statt.
                        </p>
                        <p>
                            Weitere Informationen zu Google Fonts finden Sie unter
                            {' '}<a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">
                            https://developers.google.com/fonts/faq
                        </a>
                            {' '}und in der Datenschutzerklärung von Google:
                            {' '}<a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">
                            https://policies.google.com/privacy?hl=de
                        </a>
                        </p>
                    </section>

                    <div className="policy-footer-text">
                        <p>Stand: Februar 2025</p>
                    </div>
                </div>

                <div className="policy-actions">
                    <button className="back-btn" onClick={() => navigate(-1)}>
                        ← Zurück
                    </button>
                    <button className="home-btn" onClick={() => navigate('/')}>
                        Zur Startseite
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;
